import { getField, updateField } from "vuex-map-fields";
import keycloak from "./keycloak.js";
import { ENABLE_EXTREME_FORMS_SSO_SYNC } from "../../../env.js";

const initialState = () => ({
  user: {},
  externalLoginLoadingBar: false,
  externalLoginErrorMessage: false,
  errorMsgExternalProvider: "",
  errorMessages: [],
  loadingResources: true,
  query: null,
});

export const state = initialState();

export const getters = {
  getField,
  isAuthenticated(state) {
    return Object.keys(state.user).length > 0;
  },
  hasPermission: (state) => (authority) => {
    if (state.user.authorities === null) return false;
    return state.user.authorities.includes(authority);
  },
  getAccountManagementUrl(state) {
    return keycloak.createAccountUrl();
  },
  getVersaoAceiteTermos(state) {
    return state.user.versaoAceiteTermos;
  },
};

export const actions = {
  setUser({ commit, state }, user) {
    commit("updateField", { path: `user`, value: user });
  },
  logout({ commit, dispatch }, expired) {
    dispatch("theme/resetState", null, { root: true });
    dispatch("assets/resetState", null, { root: true });
    dispatch("functions/resetState", null, { root: true });
    dispatch("common/resetState", null, { root: true });
    dispatch("perfis/resetState", null, { root: true });
    dispatch("users/resetState", null, { root: true });
    dispatch("audit/resetState", null, { root: true });
    dispatch("localidade/resetState", null, { root: true });
    dispatch("params/resetState", null, { root: true });
    dispatch("files/resetState", null, { root: true });
    commit("resetState");
    commit("logout", expired ? expired : false);
  },

  resetState({ commit }) {
    commit("resetState");
  },

  async loadSession({ state, dispatch, commit }) {
    commit("updateField", { path: "loadingResources", value: true });

    const parsedToken = parseJwt(keycloak.token);
    let groups = parsedToken["groups"];
    let group = groups.find((g) => g.includes("PERFIL"));
    group = group ? group.split("/")[2] : "";
    let segmentation = groups.find((g) => g.includes("SEGMENTACAO"));
    segmentation = segmentation ? segmentation.split("/")[2] : "";

    const user = {
      name: parsedToken.name,
      username: parsedToken.preferred_username,
      email: parsedToken.email,
      group: group,
      authorities: parsedToken.authorities,
      nmMunicipio: parsedToken.nmMunicipio,
      segmentation: segmentation,
      versaoAceiteTermos: parsedToken.versao_aceite_termos,
    };

    commit("updateField", { path: "user", value: user });

    commit("updateField", { path: "token", value: keycloak.token });

    await dispatch("assets/loadImages", null, { root: true }).catch((error) => {
      commit("addErrorMessage", error);
    });

    await dispatch("theme/getDefaultTheme", null, { root: true }).catch(
      (error) => {
        commit("addErrorMessage", error);
      }
    );

    await dispatch("functions/loadExternalFunctions", state.user.authorities, {
      root: true,
    }).catch((error) => {
      commit("addErrorMessage", error);
    });

    commit("updateField", { path: "loadingResources", value: false });
  },
  loadingExternalLogin({ state, dispatch, commit }) {
    commit("updateField", { path: "externalLoginLoadingBar", value: true });
  },
  failExternalLogin({ state, dispatch, commit }) {
    commit("updateField", { path: "externalLoginLoadingBar", value: false });
    commit("updateField", { path: "externalLoginErrorMessage", value: true });
    commit("updateField", {
      path: "errorMsgExternalProvider",
      value: "Usuário não autorizado",
    });
  },
  tryRefreshToken({ state, dispatch, commit }) {
    const tokenMinValidity = 600;
    if (keycloak.isTokenExpired()) {
      keycloak.updateToken(tokenMinValidity).catch(function (error) {
        console.log("Error keycloak tryRefreshToken", error);
        dispatch("logout", true);
      });
    }
  },
  refreshToken({ state, dispatch, commit }) {
    keycloak.updateToken(-1).catch(function () {
      dispatch("logout", true);
    });
  },
};

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const mutations = {
  updateField,
  token(state, data) {
    state.token = data;
  },
  logout(state, expired = false) {
    if (ENABLE_EXTREME_FORMS_SSO_SYNC)
      document.cookie =
        "sivsPendingFormsSSOSync=true; path=/; secure; samesite=None;";
    state.loadingResources = false;
    state.user = {};
    state.currentRoute = "/home";
    if (expired) keycloak.login();
    else keycloak.logout();
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  addErrorMessage(state, error) {
    state.errorMessages.push(error);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
